import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=58b7814c&scoped=true&"
import script from "./InviteUser.vue?vue&type=script&lang=js&"
export * from "./InviteUser.vue?vue&type=script&lang=js&"
import style0 from "./InviteUser.vue?vue&type=style&index=0&id=58b7814c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b7814c",
  null
  
)

export default component.exports